module.exports = __webpack_public_path__ + "static/media/Tablet_-_Food-and-Wine-Banner-1476x114@2x.8b493179.webp";